/* eslint-disable no-useless-escape */

export const getFloatFromString = (str: string) =>
  parseFloat(str.replace(/[^\d\.\-]*/g, ""));
